import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const MSAC_FINAL_RESULTS_REQUEST = 'FETCH_MSAC_FINAL_RESULTS_REQUEST';
export const MSAC_FINAL_RESULTS_FAILURE = 'FETCH_MSAC_FINAL_RESULTS_FAILURE';
export const MSAC_FINAL_RESULTS_SUCCESS = 'FETCH_MSAC_FINAL_RESULTS_SUCCESS';

/**
 * Final MSAC standings for one competition. All numbers (points, placings,
 * totals) are calculated by the backend's MsacScoreCalculator — the UI only
 * displays the payload, never derives values.
 *
 * A 422 carries a meaningful validation message (missing shooting protocol,
 * athletes without a score, …) — kept in the store so the protocol page can
 * show it instead of a generic failure.
 */
/*
 * ONLY THE LATEST ANSWER IS SHOWN. Two scores saved in quick succession each
 * re-read the standings; when the first answer arrived LAST it overwrote the
 * second, and the shooting tab showed a tie as not shared until something
 * else re-read them (the full E2E run, 20 Oct 2026). An answer to a request
 * older than the latest one for the same competition is dropped.
 */
const latestRequest = {};

export const fetchMsacFinalResults = (competitionId) => {
    return function(dispatch) {
        const sequence = (latestRequest[competitionId] || 0) + 1;
        latestRequest[competitionId] = sequence;
        dispatch({ type: MSAC_FINAL_RESULTS_REQUEST, competitionId });
        return axios(apiRequestOptions(apiPath.MSAC_FINAL_RESULTS.GET, null, {
            params: { competition: competitionId },
        }))
            .then(transformHttpResponse)
            .then(response => (sequence === latestRequest[competitionId]
                ? dispatch({ type: MSAC_FINAL_RESULTS_SUCCESS, data: response.data, competitionId })
                : null))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                // Symfony HttpException JSON uses `message`; API Platform
                // resources use `detail` / `hydra:description`.
                const message = (error.data
                    && (error.data.message || error.data.detail || error.data['hydra:description'])) || null;
                dispatch({ type: MSAC_FINAL_RESULTS_FAILURE, competitionId, message });
                if (!message) {
                    dispatch(errorRequestHandler(error));
                }
            });
    }
};
